import React, { useEffect, useState } from 'react';
import AdministrationForm from '../UI/AdministrationForm/AdministrationForm';
import { mdlPlace, mdlTable, mdlMenu } from '../../Models/mdlRestaurant';
import apiService from '../../Services/apiServices';

const Restaurant = (params) => {
  const [places, setPlaces] = useState([]);
  const [componentType, setComponentType] = useState("");
  const [modelInstance, setModelInstance] = useState(null);

  const getPlaces = () => {
    apiService()
      .get('places')
      .then((response) => {
        if (response.success) {
          let records = response.data.map((record) => ({
            value: record.id,
            label: record.name,
          }));
          setPlaces(records);
        }
      });
  };

  const tableTypes = [
    { value: 1, label: 'Tavolinë' },
    { value: 2, label: 'Banak' },
  ];

  const headers = [
    { key: 'name', columnName: 'Emri', typeOfInput: 'input', required: true },
    componentType === 'tables' && {
      key: 'chairs',
      columnName: 'Numri i karrigeve',
      typeOfInput: 'input',
      required: false,
    },
    componentType === 'tables' && {
      key: 'placeId',
      columnName: 'Hapësira',
      typeOfInput: 'select',
      options: places,
      required: true,
    },
    componentType === 'tables' && {
      key: 'type',
      columnName: 'Lloji',
      typeOfInput: 'select',
      options: tableTypes,
      required: true,
    },
  ].filter(Boolean);

  useEffect(() => {
    getPlaces();
    let pathname = params?.location?.pathname;
    let cleanedPathname = pathname?.replace(/^\//, '');
    setComponentType(cleanedPathname);

    // Set the appropriate model instance based on the cleanedPathname
    switch (cleanedPathname) {
      case 'places':
        setModelInstance(new mdlPlace());
        break;
      case 'tables':
        setModelInstance(new mdlTable());
        break;
      case 'menus':
        setModelInstance(new mdlMenu());
        break;
      default:
        setModelInstance(null);
    }
  }, [params]);

  return (
    <div>
      {componentType && modelInstance && (
        <AdministrationForm
          headers={headers}
          table={componentType}
          name={componentType.toUpperCase()}
          model={modelInstance}
        />
      )}
    </div>
  );
};

export default Restaurant;
